module.exports = __webpack_public_path__ + "img/mc.51a8680e.svg";